import React from "react"
import drop_down from './../images/icons/drop-down.png'

export default ({ currentPage, count, setPage }) => {
  const prevs = [...Array(currentPage > 2 ? currentPage - 2 : 0)].filter((item, index) => index < 3)
  return (
    count > 1 ? <div className="pagination flexed fl-c ltr">
      {/* prev icon, if current page is not first page */}
      {currentPage > 1 && <button className="bd-none bg-none icon-button p-0" onClick={() => setPage(currentPage - 1)}>
        <div style={{ transform: 'rotate(90deg)', padding: '4px 0 1px' }} >
          <img src={drop_down} className="icon-xs m-8" alt="" />
        </div>
      </button>}
      {/* first page, if current page is not first page */}
      {currentPage > 1 && <button className="bd-none bg-none icon-button p-8 mr-16" onClick={() => setPage(1)}>
        <span className="blocked iran-sans font-12" style={{ width: 15, lineHeight: '1.4' }}>{1}</span>
      </button>}

      {/* prev pages, if exists */}
      {
        prevs.map((item, index) => (
          <button key={index} className="bd-none bg-none p-8" onClick={() => setPage(currentPage - (prevs.length - index))}>
            <span className="blocked iran-sans font-12" style={{ width: 15, lineHeight: '1.4' }}>{currentPage - (prevs.length - index)}</span>
          </button>
        ))
      }

      {/* current page */}
      <button className="bd-none bg-tomato-lighter p-8 bold radius-4 mx-16">
        <span className="blocked iran-sans font-12 text-tomato" style={{ width: 15, lineHeight: '1.4' }}>{currentPage}</span>
      </button>

      {/* next pages, if exists */}
      {
        [...Array(count > currentPage ? (count - currentPage - 1) : 0)].filter((item, index) => index < 3).map((item, index) => (
          <button key={index} className="bd-none bg-none p-8" onClick={() => setPage(index + currentPage + 1)}>
            <span className="blocked iran-sans font-12" style={{ width: 15, lineHeight: '1.4' }}>{index + currentPage + 1}</span>
          </button>
        ))
      }

      {/* last page, if current page is not last page */}
      {currentPage !== count && <button className="bd-none bg-none icon-button p-8 ml-16" onClick={() => setPage(count)}>
        <span className="blocked iran-sans font-12" style={{ width: 15, lineHeight: '1.4' }}>{count}</span>
      </button>}
      {/* next icon, if current page is not last page */}
      {currentPage !== count && <button className="bd-none bg-none icon-button p-0" onClick={() => setPage(currentPage + 1)}>
        <div style={{ transform: 'rotate(-90deg)', padding: '4px 0 1px' }}>
          <img src={drop_down} className="icon-xs m-8" alt="" />
        </div>
      </button>}
    </div> : <div></div>
  )
}
